import gsap from 'gsap';

$(document).on('click', '[data-modal]', function () {
  $('.rw-media__image').addClass('focus');
  $('.modal').removeClass('active');
  var modal = $(this).attr('data-modal');
  $('#modal--' + modal).addClass('active');

  const open = gsap.timeline({
    paused: true,
  });

  open
    .to('.modal.active', 0.3, {
      autoAlpha: 1,
      opacity: 1,
      ease: 'easeInOut',
      display: 'block',
    })
    .to(
      '.modal.active .modal__wrapper',
      0.4,
      {
        // x: "0",
        opacity: 1,
        ease: 'easeInOut',
      },
      '<'
    )
    .staggerTo(
      '.modal.active .modal__wrapper__content, .modal__close',
      0.05,
      {
        y: '0',
        autoAlpha: 1,
        opacity: 1,
        ease: 'easeInOut',
      },
      '<'
    )
    .to('html, body', {
      overflow: 'hidden',
    });
  // .to('.modal.active .modal__wrapper', 0.2, {
  //     clipPath: 'polygon(0% 100%, 100% 100%, 100% 0, 0% 0, 0 0%)',
  //     ease: "easeInOut",
  // },0.4, '<')

  const open_mobile = gsap.timeline({
    paused: true,
  });

  open_mobile
    .to('.modal.active', 0, {
      autoAlpha: 1,
      opacity: 1,
      ease: 'easeInOut',
      display: 'block',
    })
    .to('.modal.active .modal__wrapper', 0, {
      // x: "0",
      opacity: 1,
      ease: 'easeInOut',
    })
    .staggerTo('.modal.active .modal__wrapper__content, .modal__close', 0, {
      // y: "0",
      autoAlpha: 1,
      // opacity: 1,
      ease: 'easeInOut',
    })
    .to('html, body', {
      overflow: 'hidden',
    });
  // .to('.modal.active .modal__wrapper', 0.2, {
  //     clipPath: 'polygon(0% 100%, 100% 100%, 100% 0, 0% 0, 0 0%)',
  //     ease: "easeInOut",
  // },0.4, '<')

  const timelineToggle = (timeline) => {
    if (timeline.progress() < 1) {
      timeline.play();
    } else {
      timeline.restart();
    }
  };

  // const removeItems = () => {

  // }

  if (window.innerWidth <= 992) {
    timelineToggle(open_mobile);
  } else {
    timelineToggle(open);
  }
});

$(document).on('click', '.modal__close', function () {
  $('.modal').removeClass('active');

  var modal = $('#modal--videoModal');
  if (modal.length) {
    modal.find('video').get(0).pause();
  }

  const close = gsap.timeline({
    paused: true,
    defaults: { clearProps: true },
  });

  close
    .to('html, body', {
      overflow: '',
    })
    .to(
      '.modal',
      0.3,
      {
        autoAlpha: 0,
        opacity: 0,
        ease: 'easeInOut',
        display: 'block',
      },
      '<'
    )
    .to(
      '.modal .modal__wrapper',
      0.4,
      {
        // x: "-100%",
        opacity: 0,
        ease: 'easeInOut',
      },
      '<'
    )
    .staggerTo('.modal .modal__wrapper__content, .modal__close', 0.05, {
      y: '-100%',
      autoAlpha: 0,
      opacity: 0,
      ease: 'easeInOut',
    });

  const close_mobile = gsap.timeline({
    paused: true,
    defaults: { clearProps: true },
  });

  close_mobile
    .to('.modal__close', 0, {
      opacity: 0,
    })
    .to('html, body', {
      overflow: '',
    })
    .to('.modal', 0, {
      autoAlpha: 0,
      opacity: 0,
      ease: 'easeInOut',
      display: 'block',
    })
    .to('.modal .modal__wrapper', 0, {
      // x: "-100%",
      opacity: 0,
      ease: 'easeInOut',
    })
    .staggerTo('.modal .modal__wrapper__content', 0, {
      // y: "-100%",
      autoAlpha: 0,
      // opacity: 0,
      ease: 'easeInOut',
    });

  const timelineToggle = (timeline) => {
    if (timeline.progress() < 1) {
      timeline.play();
    } else {
      timeline.restart();
    }
  };

  const removeItems = () => {};

  if (window.innerWidth <= 992) {
    removeItems();
    timelineToggle(close_mobile);
  } else {
    removeItems();
    timelineToggle(close);
  }

  setTimeout(function () {
    $('.rw-media__image').removeClass('focus');
  }, 600);
});

const close = gsap.timeline({
  paused: true,
  defaults: { clearProps: true },
});

close
  .to('html, body', {
    overflow: '',
  })
  .to(
    '.modal',
    0.3,
    {
      autoAlpha: 0,
      opacity: 0,
      ease: 'easeInOut',
      display: 'block',
    },
    '<'
  )
  .to(
    '.modal .modal__wrapper',
    0.4,
    {
      // x: "-100%",
      opacity: 0,
      ease: 'easeInOut',
    },
    '<'
  )
  .staggerTo('.modal .modal__wrapper__content, .modal__close', 0.05, {
    y: '-100%',
    autoAlpha: 0,
    opacity: 0,
    ease: 'easeInOut',
  });

const timelineToggle = (timeline) => {
  if (timeline.progress() < 1) {
    timeline.play();
  } else {
    timeline.restart();
  }
  timeline.play();
};

const removeItems = () => {};

$(document).on('keydown', function (event) {
  if (event.keyCode === 27 || event.key === 'Escape') {
    // var style = $('.modal.active .modal__wrapper').css('clip-path');
    // if(style == 'polygon(0% 100%, 100% 100%, 100% 0px, 0% 0px, 0px 0%)') {
    //     removeItems();
    //     timelineToggle(close);
    //     $('.modal').removeClass('active');
    // }
    var style = $('body').css('overflow');
    if (style == 'hidden') {
      removeItems();
      timelineToggle(close);
      $('.modal').removeClass('active');
      var modal = $('#modal--videoModal');
      if (modal.length) {
        modal.find('video').get(0).pause();
      }
    }

    setTimeout(function () {
      $('.rw-media__image').removeClass('focus');
    }, 600);
  }
});

$(document).mouseup(function (e) {
  if ($('.modal').is(':visible')) {
    var container = $('.modal__wrapper');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      removeItems();
      timelineToggle(close);
      $('.modal').removeClass('active');
      var modal = $('#modal--videoModal');
      if (modal.length) {
        modal.find('video').get(0).pause();
      }
      setTimeout(function () {
        $('.rw-media__image').removeClass('focus');
      }, 600);
    }
  }
});

$(window).on('resize', function () {
  if ($('.modal').is(':visible')) {
    removeItems();
    timelineToggle(close);
    $('.modal').removeClass('active');
    var modal = $('#modal--videoModal');
    if (modal.length) {
      modal.find('video').get(0).pause();
    }
    setTimeout(function () {
      $('.rw-media__image').removeClass('focus');
    }, 600);
  }
});
